import { defaultLogo } from '..'
import { useTw } from '../Styles'
import { useTranslation } from 'react-i18next'

type User = {
  _id: string
  name?: string
  logoURL?: string
}

export function Avatars({ users = [] }: { users: Array<User> }) {
  const tw = useTw()
  const [t] = useTranslation('common')
  const usrs = users.filter((_) => _?._id)
  return (
    <div className={tw(`whitespace-nowrap flex-shrink-0 -space-x-3`)}>
      {[usrs[0], usrs[1], usrs[2]]
        .filter((_) => !!_)
        .map((user, i) => (
          <img
            src={user.logoURL || defaultLogo}
            key={user.name || `default:${i}`}
            alt={t('avatars.alt', { name: user.name })}
            className={tw`select-none inline-block border border-transparent border-white h-10 w-10 bg-white object-cover rounded-full`}
          />
        ))}
    </div>
  )
}
